import { render, staticRenderFns } from "./Noticed.vue?vue&type=template&id=0b9e15c4&scoped=true"
import script from "./Noticed.vue?vue&type=script&lang=js"
export * from "./Noticed.vue?vue&type=script&lang=js"
import style0 from "./Noticed.vue?vue&type=style&index=0&id=0b9e15c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e15c4",
  null
  
)

export default component.exports